import { Link } from 'react-router-dom';
import { AppWindow, Building2 } from 'lucide-react';
import { runResultHref, type RunContext, type WorkRun } from '@/lib/work-runs';
import { RowIdentity } from './work-row-visuals';
import { whenDone } from './work-done';

/**
 * Work I finished today whose task left the file: it stays, in grey, until
 * tomorrow, with where to read its result.
 */
export const TodayDoneRow = ({ run, context, now }: { run: WorkRun; context: RunContext | null; now: Date }) => {
  const href = runResultHref(run, context);
  const failed = run.status === 'failed';
  return (
    <article className="rounded-lg border border-domino-cardBorder bg-domino-white px-3.5 py-3 sm:rounded-none sm:border-0">
      <div className="work-action-row">
        <div className="work-account min-w-0 opacity-70">
          <RowIdentity icon={context?.accountSubjectId ? Building2 : AppWindow} label={context?.label ?? 'Travail'} />
        </div>
        <div className="work-menu" />
        <div className="work-title min-w-0">
          <h3 className="text-sm font-normal leading-5 text-domino-inkSoft">{run.label}</h3>
          <p className="mt-0.5 text-xs leading-4 text-domino-inkSoft">{failed ? 'Échec' : 'Fait'} à {whenDone(run.finishedAt, now)}</p>
        </div>
        <div className="work-command flex min-w-0 items-center gap-3 text-xs">
          <span className={failed ? 'text-domino-inkSoft' : 'font-semibold text-emerald-700'}>{failed ? 'Échec' : '✓ Fait'}</span>
          {href && <Link to={href} className="text-domino-aubergine underline underline-offset-2">Voir</Link>}
        </div>
      </div>
    </article>
  );
};
